import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import SydButton from '../../../../commonDesign/Button'
import { useDeletePersonMutation, useInvalidatePeopleSearch } from '../../../../../api/people'
import SnackAlert from '../../../../molecules/SnackAlert/SnackAlert'

const DeleteButtonCell = ({ value, row }) => {
  const [open, setOpen] = React.useState(false)
  const userId = row.original?.user?.externalUserId
  const [error, setError] = React.useState(null)
  const personId = row.original.personId
  const { mutateAsync, isLoading } = useDeletePersonMutation()
  const invalidate = useInvalidatePeopleSearch()
  const handleDelete = async () => {
    try {
      const result = await mutateAsync({ personId })
      if (result) {
        invalidate()
      }
    } catch (err) {
      setError({ alertMessage: 'Error deleting person.', openAlert: true, alertSeverity: 'error' })
    }
  }
  return (
    <div className='flex items-center justify-center gap-2'>
      {!userId ? (
        open ? (
          <>
            <SydButton
              size='sm'
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                handleDelete()
              }}
              processing={isLoading}
              priority='warning'
              icon='delete'
            >
              Confirm
            </SydButton>
            <SydButton
              size='sm'
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setOpen(false)
              }}
              icon='close'
            >
              Cancel
            </SydButton>
          </>
        ) : (
          <SydButton
            size='sm'
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              setOpen(true)
            }}
          >
            Delete
          </SydButton>
        )
      ) : (
        <Typography>Cannot delete a person with an associated Wealth Owner.</Typography>
      )}
      <SnackAlert alert={error} />
    </div>
  )
}

DeleteButtonCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.any
}

export default DeleteButtonCell
